"use strict";

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alias = void 0;
/**
 * Abtract class for Aliases
 *
 * @since 0.10.2
 */

var Alias = /*#__PURE__*/_createClass(
/**
 * @internal
 * @param type - Alias type
 * @param address - Address for AddressAlias
 * @param mosaicId - MosaicId for MosaicAlias
 */
function Alias(
/**
 * The alias type
 *
 * - 0 : No alias
 * - 1 : Mosaic id alias
 * - 2 : Address alias
 */
type,
/**
 * The alias address
 */
address,
/**
 * The alias mosaicId
 */
mosaicId) {
  _classCallCheck(this, Alias);

  this.type = type;
  this.address = address;
  this.mosaicId = mosaicId;
});

exports.Alias = Alias;